import React from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import './App.css';
import './css/Map.css';
import FilterContextProvider from './contexts/FilterContextProvider';
import ProjectDataContextProvider from './contexts/ProjectDataContextProvider';
import TopNav from './components/TopNav';
import Filters from './components/Filters';
import Home from './components/Home';
import ProjectsList from './components/ProjectsList';
import ProjectSnapshot from './components/ProjectSnapshot';
import Map from './components/Map';
import RemoveMapSelection from './components/RemoveMapSelection';
import Fullscreen from './components/Fullscreen';
import MobileFooter from './components/MobileFooter';
import { LiveMessage } from 'react-aria-live';

function App() {
  const location = useLocation();

  let a11yMessage = setTitleGetA11yMessage(location);

  return (
    <>
      <FilterContextProvider>
        <TopNav/>
        <div className="container-fluid">
          <div className="row container-row">
            <ProjectDataContextProvider>
              <Filters/>
              <div id="mainContentWell" role="main" tabIndex="-1" className={location.search.indexOf('map=show') !== -1 ? "col-lg-5 mobile-map-hide" : (location.search.indexOf('map=full') !== -1 ? "hide" : "col-lg-5 mobile-map-show")}>
                <Switch>
                  <Route path={"/projects/:project"}>
                    <>
                      <ProjectsList />
                      <ProjectSnapshot />
                    </>
                  </Route>
                  
                  <Route path={"/projects"}>
                    <ProjectsList />
                  </Route>
                  
                  <Route path="/">
                    <Home/>
                  </Route>
                </Switch>
              </div>
            </ProjectDataContextProvider>

            <div id="mapContentWell" role="complementary" className={location.search.indexOf('map=show') !== -1 ? "col-lg-5 mobile-map-show" : (location.search.indexOf('map=full') !== -1 ? "col-lg-12" : "col-lg-5 mobile-map-hide")}>
              <Map />
            </div>
          </div>
        </div>

        <RemoveMapSelection />
        <Fullscreen />
        <MobileFooter />
      </FilterContextProvider>
      <LiveMessage message={a11yMessage} aria-live="polite" />
    </>
  );
}

export default App;

function setTitleGetA11yMessage(location) {
  let newTitle = "";
  let a11yMessage = "";
  
  if (location.pathname.indexOf("/projects/") === -1) {
    if (location.search === "") {
      newTitle = location.pathname.indexOf("/projects") !== -1 ? "Projects | Transportation Project Tracker" : "Home | Transportation Project Tracker";
      a11yMessage = location.pathname.indexOf("/projects") !== -1 ? "All project links displayed." : "Home content displayed.";
    }
    else {
      newTitle = location.search.indexOf("map=show") !== -1 ? "Filtered Projects - Project Map | Transportation Project Tracker" : "Filtered Projects | Transportation Project Tracker";
      a11yMessage = "Filtered project links displayed.";
    }
  }
  else {
    newTitle = "Project Details | Transportation Project Tracker";
  }

  document.title = newTitle.length ? newTitle : "Transportation Project Tracker";
  return a11yMessage;
}